<template>
    <el-container style="width:100%;">
        <el-header>
            <el-form @submit.native.prevent :inline="true" :model="fromQueue" ref="fromQueue" class="demo-form-inline">
                <td-permission :oneOfPermissions="permissionsQuery">
                    <div slot="havePermission">
                        <el-form-item :label="$t('common.QUEUE_NAME')" prop="sChannelName">
                            <td-input v-model="fromQueue.sChannelName"></td-input>
                        </el-form-item>
                        <el-form-item class="paddingLeft10">
                            <td-button type="primary" :loading="loading" :permissions="permissionsQuery" @getPermissionsStatus="getPermissionsStatus" @click="btnQuery">{{
                                $t('common.QUERY')
                            }}</td-button>
                        </el-form-item>
                    </div>
                </td-permission>
                <el-form-item>
                    <td-button type="button" :permissions="permissionsAdd" @click="btnAddqueue">{{ $t('common.ADD') }}</td-button>
                    <td-button type="button" :permissions="permissions" @click="btnQueryAssocitionList">{{ $t('common.ASSOCIATION_LIST') }}</td-button>
                </el-form-item>
            </el-form>
        </el-header>
        <el-main>
            <td-table
                :columns="columns"
                :permissions="permissionsQuery"
                :dataSource="tableData"
                :pageSize="pageSize"
                :currentPage="currentPage"
                :hasLoading="tableLoading"
                :total="total"
                @handleSizeChange="handleSizeChange"
                @currentChange="currentChange"
                :hasMutiSelect="false"
            ></td-table>
            <!-- 添加队列dialog -->
            <dialog-QueueInfo
                v-if="dialogQueueVisible"
                :isAddData="isAddData"
                :dialogQueueVisible="dialogQueueVisible"
                :listMqInfo="listMqInfo"
                :editItem="editItem"
                :title="title"
                ref="addOrModifyInfo"
                @queueDialogClose="queueDialogClose"
                @submit="submit"
            ></dialog-QueueInfo>
            <!-- 加载关联列表dialog -->
            <dialog-AssocitionList
                v-if="dialogassocitionListVisible"
                :dialogassocitionListVisible="dialogassocitionListVisible"
                :associtionListData="associtionListData"
                :title="title"
                @associtionListDlgClose="associtionListDlgClose"
                @submit="submit"
            ></dialog-AssocitionList>
        </el-main>
    </el-container>
</template>

<script>
import queueApi from './assets/api.js';
import dialogQueueInfo from './components/dialogQueueInfo.vue';
import dialogAssocitionList from './components/dialogAssocitionList.vue';
export default {
    // 初始化渲染
    components: {
        'dialog-QueueInfo': dialogQueueInfo,
        'dialog-AssocitionList': dialogAssocitionList
    },

    // 在页面渲染完成之后进行初始化工作
    mounted() {
        //this.queryDataList(); // 进行页面初始化数据的加载
    },

    // 定义数据
    data() {
        return {
            permissionsQuery: ['exchange:view'],
            permissionsAdd: ['exchange:add'],
            permissions: ['exchangeref:view'],
            fromQueue: { sChannelName: '' },
            formName: 'fromQueue', // 表单名称
            editItem: '',
            associtionListData: [], // 关联列表数据
            listMqInfo: [],
            listProInfo: [], // 生产者集合
            listCsmInfo: [], // 消费者集合
            dialogQueueVisible: false,
            dialogRelatedSetVisible: false,
            dialogassocitionListVisible: false,
            tableData: [],
            isAddData: true, // 是否为添加数据
            pageSize: 10, // 每页条数
            currentPage: 1, // 当前页
            total: 0, // 总条数
            dataCount: 0,
            loading: false,
            tableLoading: false,
            columns: [
                {
                    prop: 'sChannelName',
                    label: 'common.QUEUE_NAME'
                },
                {
                    prop: 'sMqName',
                    label: 'common.BELONGED_MQ'
                },
                {
                    prop: 'iMode',
                    label: 'common.TRANSFER_MODE',
                    tableWidth: '120',
                    align: 'center',
                    render: (createElement, params) => {
                        return createElement('label', this.transferModeType(params.row));
                    }
                },
                {
                    prop: 'iDurable',
                    label: 'common.PERSISTENCE',
                    tableWidth: '100',
                    align: 'center',
                    render: (createElement, params) => {
                        return createElement('label', this.iDurable(params.row));
                    }
                },
                {
                    prop: 'iPriority',
                    label: 'common.I_PRIORITY',
                    tableWidth: '150',
                    align: 'center',
                    render: (createElement, params) => {
                        return createElement('label', this.iPriority(params.row));
                    }
                },
                {
                    prop: 'iMessagettl',
                    label: 'common.IMESSAGETTL_TYPE',
                    tableWidth: '150',
                    align: 'center',
                    render: (createElement, params) => {
                        return createElement('label', this.iMessagettl(params.row));
                    }
                },
                {
                    prop: 'iChannelMaxLength',
                    label: 'common.MQ_CHANNEL_MAX_LENGTH',
                    tableWidth: '120',
                    align: 'right'
                },
                {
                    prop: 'sDescription',
                    label: 'common.DESCRIPTION',
                    showOverflowTooltip: true
                },
                {
                    prop: '',
                    label: 'common.OPERATE',
                    tableWidth: '90',
                    align: 'center',
                    render: (createElement, params) => {
                        let a1 = createElement(
                            'td-button',
                            {
                                props: { type: 'text', size: 'small', permissions: ['exchange:edit'] },
                                on: {
                                    click: () => {
                                        this.btnExit(params.row);
                                    }
                                }
                            },
                            this.$t('common.EDIT')
                        );
                        let a2 = createElement(
                            'td-button',
                            {
                                props: { type: 'text', size: 'small', permissions: ['exchange:del'] },
                                on: {
                                    click: () => {
                                        this.btnDelete(params.row.sId);
                                    }
                                }
                            },
                            this.$t('common.DELETE')
                        );
                        let list = [];
                        if (params.row.iEnableDeleteFlg === 0) {
                            list.push(a1);
                            list.push(a2);
                        }
                        return createElement('div', list);
                    }
                }
            ]
        };
    },
    // 方法的实现
    methods: {
        //页面权限设置
        getPermissionsStatus(permissions) {
            if (permissions) {
                this.btnQuery(); // 进行页面初始化数据的加载
            }
        },
        // 根据id显示对应的传输模式
        transferModeType(row) {
            switch (row.iMode) {
                case 0:
                    return this.$t('common.WORKQUEUE');
                    // eslint-disable-next-line no-unreachable
                    break;
                case 1:
                    return this.$t('common.FANOUT');
                    // eslint-disable-next-line no-unreachable
                    break;
                case 2:
                    return this.$t('common.DIRECT');
                    // eslint-disable-next-line no-unreachable
                    break;
                case 3:
                    return this.$t('common.TOPIC');
                    // eslint-disable-next-line no-unreachable
                    break;
                default:
                    return this.$t('common.WORKQUEUE');
            }
        },

        // 是否持久化
        iDurable(row) {
            switch (row.iDurable) {
                case 1:
                    return this.$t('common.YES');
                    // eslint-disable-next-line no-unreachable
                    break;
                default:
                    return this.$t('common.NOT');
            }
        },
        // 是否启用消息优先级
        iPriority(row) {
            switch (row.iPriority) {
                case 1:
                    return this.$t('common.ISUSING');
                    // eslint-disable-next-line no-unreachable
                    break;
                default:
                    return this.$t('common.UNUSING');
            }
        },
        // 消息有效期
        iMessagettl(row) {
            if (row.iMessagettl === 0) {
                return this.$t('common.PERMANENT');
            } else {
                return row.iMessagettl + this.$t('common.IMESSAGE_SECONDS');
            }
        },

        // 获取每页条数
        handleSizeChange(pageSize) {
            this.pageSize = pageSize;
            this.submit();
        },

        // 获取当前页
        currentChange(currentPage) {
            this.currentPage = currentPage;
            this.submit();
        },

        // 查询数据
        btnQuery() {
            this.loading = true;
            this.currentPage = 1;
            this.queryDataList();
        },
        // 查询数据
        queryDataList() {
            let param = {
                sChannelName: this.fromQueue.sChannelName,
                currentPage: this.currentPage,
                pageSize: this.pageSize
            };
            queueApi.queryMqChannelInfo(JSON.stringify(param), response => {
                if (response.status !== window.pgCommon.login.RESPONSE_STATUS) {
                    this.loading = false;
                    this.$log.error('queueManagement/queryMqChannelInfo', response);
                    return;
                }
                if (response.data.statusCode !== window.pgCommon.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('queueManagement/queryMqChannelInfo', response.data.statusMessage);
                    this.loading = false;
                    return;
                }
                this.tableData = response.data.content;
                this.total = response.data.count;
                this.loading = false;
            });
        },
        // 查询关联列表
        btnQueryAssocitionList() {
            this.title = this.$t('common.ASSOCIATION_LIST'); // 关联列表
            this.dialogassocitionListVisible = true;
        },

        // 添加
        btnAddqueue() {
            this.listMqInfo = [];
            let params = {
                isPage: false
            };
            queueApi.queryMqInfo(params, response => {
                if (response.status !== window.pgCommon.login.RESPONSE_STATUS) {
                    this.$log.error('queueManagement/queryMqInfo', response);
                    return;
                }
                if (response.data.statusCode !== window.pgCommon.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('queueManagement/queryMqInfo', response.data.statusMessage);
                    return;
                }
                let mqInfos = response.data.content;
                for (let i = 0; i < mqInfos.length; i++) {
                    let mqInfo = {};
                    mqInfo.value = mqInfos[i].sId;
                    mqInfo.label = mqInfos[i].sName;
                    this.listMqInfo.push(mqInfo);
                }
                this.title = this.$t('common.ADD'); // 标题
                this.isAddData = true;
                this.dialogQueueVisible = true;
            });
        },
        // 编辑
        btnExit(row) {
            this.listMqInfo = [];
            let params = {
                isPage: false
            };
            queueApi.queryMqInfo(params, response => {
                if (response.status !== window.pgCommon.login.RESPONSE_STATUS) {
                    this.$log.error('queueManagement/queryMqInfo', response);
                    return;
                }
                if (response.data.statusCode !== window.pgCommon.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('queueManagement/queryMqInfo', response.data.statusMessage);
                    return;
                }
                let mqInfos = response.data.content;
                for (let i = 0; i < mqInfos.length; i++) {
                    let mqInfo = {};
                    mqInfo.value = mqInfos[i].sId;
                    mqInfo.label = mqInfos[i].sName;
                    this.listMqInfo.push(mqInfo);
                }
                this.editItem = row;
                this.title = this.$t('common.EDIT'); // 标题
                this.isAddData = false;
                this.dialogQueueVisible = true;
            });
        },

        // 删除接口
        btnDelete(channelId) {
            this.$confirm(this.$t('common.DELETE_INFO_TIPS'), this.$t('common.TIPS'), {
                confirmButtonText: this.$t('common.SURE'),
                cancelButtonText: this.$t('common.CANCEL'),
                type: 'warning'
            })
                .then(() => {
                    this.tableLoading = true;
                    let param = { channelId: channelId };
                    queueApi.deleteMqChannel(param, response => {
                        this.tableLoading = false;
                        if (response.data.statusCode !== window.pgCommon.requestCode.SUCCESS_INFO_CODE) {
                            this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                            this.$log.error('queueManagement/deleteMqChannel', response.data.statusMessage);
                            return;
                        }
                        this.$message({ type: 'success', showClose: true, message: this.$t('pgCommon.DELETE_SUCCESS') });
                        this.submit();
                    });
                })
                .catch(() => {});
        },

        // 组件关闭需要调用的方法
        submit() {
            this.queryDataList();
        },

        // 关闭队列信息页面
        queueDialogClose() {
            this.dialogQueueVisible = false;
        },

        // 关闭关联设置页面
        relatedSetDlgClose() {
            this.dialogRelatedSetVisible = false;
        },
        // 关闭关联列表页面
        associtionListDlgClose() {
            this.dialogassocitionListVisible = false;
        }
    }
};
</script>
